package chat.amp.tim

import de.connect2x.trixnity.messenger.util.DownloadManager
import kotlinx.coroutines.CoroutineScope
import org.koin.dsl.module

fun ampModule() = module {
    //single<DownloadManager> { ampDownloadManagerImpl(get<CoroutineScope>().coroutineContext) }
}
